export default __webpack_public_path__ + "static/media/icon-info.df9aa518.svg";